import styled from 'styled-components';
import {ListTitleDefaultBox}  from "./list-title.default.box";

export const ListTitleCipBox = styled(ListTitleDefaultBox)`
    &:before {
      display: none;
    }
`;
